export type UserProfileRole = string | string[];
export const CUSTOMER_LOGIN_TYPE = "A";
export const CONSIGNEE_LOGIN_TYPE = "B";
export const CARRIER_LOGIN_TYPE = "C";
export const ABECASUSER_LOGIN_TYPE = "D";
export const disableTransDate = (r: UserProfileRole) => {
    let loginTypes: string[] = [];
    if (r === undefined || r === null) {
        loginTypes.push(CUSTOMER_LOGIN_TYPE);
    } else {

        if (Array.isArray(r)) {
            loginTypes = r;
        } else {
            loginTypes.push(r as string);
        }
    }

    if (
        loginTypes.findIndex(rr => rr === ABECASUSER_LOGIN_TYPE) > -1) {
        return false;
    }
    return loginTypes.findIndex(rr => rr === CARRIER_LOGIN_TYPE
        || rr === CONSIGNEE_LOGIN_TYPE
        || rr === CUSTOMER_LOGIN_TYPE) > -1
}

// WM - Carrier - Scheduling (WM-CARRIER-SCHED) permissions.
//
// GetPermissionsByRole returns a dictionary keyed by the permission's Display GroupName, whose
// values are the enum member names with that group prefix stripped - so authorization-server member
// `WMSchedulingSeeAvailableSlots` arrives as group "WMScheduling", value "SeeAvailableSlots".
export const WM_SCHEDULING_GROUP = "WMScheduling";

export const SCHEDULING_PERMISSIONS = {
    SEE_AVAILABLE_SLOTS: "SeeAvailableSlots",
    SCHEDULE_INTO_AVAILABLE_SLOT: "ScheduleIntoAvailableSlot",
    APPROVE_REJECT_SCHEDULE_REQUEST: "ApproveRejectScheduleRequest",
    OVERRIDE_CARRIER_CODE: "OverrideCarrierCode",
    SEE_OTHER_CARRIER_SHIPMENTS: "SeeOtherCarrierShipments",
};

/**
 * Whether the role's permissions (the redux `rolePermissions` dictionary populated from
 * GetPermissionsByRole) include a WM Scheduling permission. Server-side checks back each of these
 * up, so this only decides whether a control is worth rendering.
 */
export const hasSchedulingPermission = (
    rolePermissions: any,
    permissionName: string,
): boolean => {
    const group = rolePermissions && rolePermissions[WM_SCHEDULING_GROUP];
    return Array.isArray(group) && group.indexOf(permissionName) > -1;
};
